import styled from "styled-components";

export const PostWrapper = styled.div`
  margin-top: 5vh;
  min-height: 300px;
  width: 100%;
`;
